import { Message } from "element-ui";
import { Toast } from "vant";
import { getTerminalInfo } from '@/utils/platformInfo';

export default function toast(msg, type = "error") {
  const isMobile = getTerminalInfo() === "mobile";
  if (isMobile) {
    Toast({
      message: msg,
      position: "bottom",
    });
  } else {
    Message[type](msg);
  }
}